// extracted by mini-css-extract-plugin
module.exports = {"visibleOnMobileLayout":"ModalInMobileExample_visibleOnMobileLayout__1w4ge"};